"use client";
import React, {useEffect, useRef} from "react";

export default function HubspotMeeting({
  meetingEmbed,
}: {
  meetingEmbed: string;
}) {
  const scriptRoot: React.MutableRefObject<null | HTMLDivElement> =
    useRef(null);
  const script = `<script type="text/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>`;

  useEffect(() => {
    if (scriptRoot.current === null) return;
    const root = scriptRoot.current;
    // creates a document range (grouping of nodes in the document is my understanding)
    // in this case we instantiate it as empty, on purpose
    const range = document.createRange();
    // creates a mini-document (light weight version), in our range with our script in it
    const documentFragment = range.createContextualFragment(script);
    // appends it to our script root - so it renders in the correct location
    root.append(documentFragment);

    return () => {
      if (!root) return;
      // removes the script from the script root
      root.querySelector("script")?.remove();
    };
  }, [script]);

  return (
    <div ref={scriptRoot}>
      <div
        className="meetings-iframe-container"
        data-src={meetingEmbed ?? ""}
      ></div>
    </div>
  );
}
